<template>
  <div class="app-content auth flex h-screen flex-row-reverse">
    <Sidebar :links="links"/>
    <main class="main">
      <Header />
      <div class="p-5 md:p-10">
        <vue-page-transition name="fade-in-up">
          <router-view :key="$route.fullPath"> </router-view>
        </vue-page-transition>
      </div>
    </main>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/layout/Header.vue";
import menuLinks from "./adminSidebarLinks.js";
import Sidebar from "@/components/layout/Sidebar.vue";

export default {
  name: "AdminLayout",
  metaInfo: {
    title: "Spyows",
    titleTemplate: "%s | Admin",
    htmlAttrs: {
      lang: "en",
      amp: true
    }
  },
  components: {
    Header,
    Sidebar
  },
  data() {
    return {
      links: menuLinks
    };
  }
};
</script>

<style lang="postcss" scoped>
main.main {
  @apply h-screen overflow-x-hidden;
  flex-basis: auto;
  flex-grow: 1;
}
</style>
